import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const Extension = props => {
  const {
    isFetching,
    optionsExtensions,
    extensionToLogin,
    handleChangeSelectLoginRamal,
    getAvailableExtensions,
    handleClickLoginRamal,
    extensionsLogged,
    extensionLogout
  } = props;

  const customStyle = {
    control: provided => ({
      ...provided,
      borderRadius: '0px',
      '&:hover': {
        color: '#495057',
        backgroundColor: '#fff',
        borderColor: '#80bdff',
        outline: 0,
        boxShadow: '0 0 0 .2rem rgba(0,123,255,.25)'
      }
    }),
    menu: provided => ({ ...provided, marginTop: '1px' }),
    downchevron: provided => ({ ...provided, borderRadius: '100px' })
  };

  const customThemes = theme => ({
    ...theme,
    colors: { ...theme.colors, primary: '#80bdff' }
  });

  const customFilter = (option, searchText) =>
    !!option.data.label.toLowerCase().includes(searchText.toLowerCase());

  return (
    <React.Fragment>
      <li>
        <div className="form-group ml-2 mr-2">
          <label className="sidebar-subtitle">Selecionar Ramal</label>
          <div className="form-row m-0">
            <div className="w-75 pl-0">
              <Select
                value={
                  optionsExtensions.find(
                    opt => opt.value === extensionToLogin.id
                  ) || { value: '', label: ' ' }
                }
                onChange={handleChangeSelectLoginRamal}
                isDisabled={isFetching}
                options={optionsExtensions}
                isSearchable={true}
                theme={customThemes}
                styles={customStyle}
                filterOption={customFilter}
                noOptionsMessage={() => 'Nenhum registro encontrado'}
              />
            </div>
            <div className="col pr-0">
              <button
                type="button"
                className="btn btn-info w-100"
                title="Atualizar Listagem"
                disabled={isFetching}
                onClick={getAvailableExtensions}
              >
                <i className="fa fa-sync-alt" />
              </button>
            </div>
          </div>
          <button
            type="button"
            className="mt-1 btn btn-info btn-block font-weight-bolder"
            disabled={isFetching}
            onClick={handleClickLoginRamal}
          >
            <i className="fa fa-link" />
            &nbsp;LOGAR NO RAMAL
          </button>
        </div>
      </li>
      <li>
        <div className="form-group ml-2 mr-2">
          <label className="sidebar-subtitle">Ramais Vinculados</label>
          <div id="extension-container">
            {extensionsLogged.map((item, index) => {
              const { id, number } = item;
              return (
                <div
                  key={id}
                  className="form-row m-auto"
                  style={{
                    backgroundColor: `${index % 2 === 0 ? '#fff' : '#ddd'}`
                  }}
                >
                  <div className="col mt-1 mb-1">
                    <p className="m-1">
                      <i className="fa fa-phone" />
                      &nbsp;{number}
                    </p>
                  </div>
                  <div className="col mt-1 mb-1">
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => extensionLogout(id, number)}
                      disabled={isFetching}
                    >
                      <i className="fa fa-unlink" />
                      &nbsp;Deslogar
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </li>
      <li>{isFetching && <p className="text-center">Processando...</p>}</li>
    </React.Fragment>
  );
};

Extension.propTypes = {
  isFetching: PropTypes.bool,
  optionsExtensions: PropTypes.array,
  extensionToLogin: PropTypes.object,
  handleChangeSelectLoginRamal: PropTypes.func,
  getAvailableExtensions: PropTypes.func,
  extensionsLogged: PropTypes.array,
  extensionLogout: PropTypes.func,
  handleClickLoginRamal: PropTypes.func
};

export default Extension;
